const reducersName = 'carDetail';

export const carDetailSelectors = {
	getAll: (state) => state[reducersName],
	getRewardOptions: (state) => state[reducersName].rewardOptions,
	isContext: (state) => state[reducersName].isContext
};
